const _ = require("lodash");

const settings = {
	infiniteAttempts: true,
	limitAttemptSpeed: true,
	neverGiveUp: true,
	hasNoSummary: true,
	canReplayProblem: true,
	canRestartSet: false,
	starProgressType: "trophy",
	skipProblemCount: true,
};

const initialize = function(result, processor) {
	return _.omit(result, [
		"starCutoffs",
		"starsAvailable",
		"botOutcomes",
		"setNumber",
	]);
};

const getPercentComplete = function(result) {
	return 0; //Percent complete doesn't make sense for single trophy problems
};

const showInstructionsOnNavigation = function(result) {
	return false;
};

const getTrialXP = function(result) {
	return 50;
};

const getStars = function(result) {
	return 0;
};

const getResultProgressXP = function(backendResult) {
	if (backendResult.finishStatus === "completed") return getTrialXP();
	else return 0;
};

const getSetProgressInfo = function(result) {
	return null;
};

const getStarProgressInfo = function(result) {
	return {
		trophyEarned: result.problems[0].outcome === "correct",
	};
};

module.exports = {
	settings,
	initialize,
	getPercentComplete,
	getTrialXP,
	getStars,
	getSetProgressInfo,
	showInstructionsOnNavigation,
	getStarProgressInfo,
	getResultProgressXP,
};
